import { Box } from '@material-ui/core';
import React from 'react';

const BlackScreen: React.FC = () => {
    return <Box height="100vh" width="100vw" style={{ backgroundColor: 'black' }}></Box>;
};
export default BlackScreen;
